module.exports = __webpack_public_path__ + "static/media/giftsReceived_750_1000.6bb49b1e.png";